import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m6.053 9-3.386 3.393v-2.06a.667.667 0 0 0-1.334 0V14q.002.132.054.253a.67.67 0 0 0 .613.414h3.667a.666.666 0 1 0 0-1.334h-2.06L7 9.947A.67.67 0 1 0 6.053 9m8.56-7.253A.67.67 0 0 0 14 1.333h-3.667a.667.667 0 0 0 0 1.334h2.06L9.063 5.99a.666.666 0 0 0 .216 1.093.67.67 0 0 0 .73-.146l3.324-3.331v2.06a.667.667 0 1 0 1.334 0V2a.7.7 0 0 0-.054-.253" }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })